import Decimal from "decimal.js";

/**
 * The minimum shape required to compute a settlement amount from a contract
 * summary row. Both `SettlementContractInfo` and `AdvanceContractInfo` (and
 * the related `AgtechTicketsContractInfo`) satisfy this shape.
 */
export interface SettlementAmountRow {
  gross_dollars: string | null;
  discounts: string | null;
  charges: string | null;
}

/**
 * Net settlement amount for a single contract summary row:
 *   gross_dollars − discounts − charges
 */
export function settlementAmountFromRow(row: SettlementAmountRow): Decimal {
  return new Decimal(row.gross_dollars ?? 0)
    .minus(new Decimal(row.discounts ?? 0))
    .minus(new Decimal(row.charges ?? 0));
}

/**
 * Net settlement total across many contract summary rows:
 *   Σ(gross_dollars − discounts − charges)
 */
export function totalSettlementAmount(rows: SettlementAmountRow[]): Decimal {
  return rows.reduce(
    (acc: Decimal, r: SettlementAmountRow) => acc.plus(settlementAmountFromRow(r)),
    new Decimal(0),
  );
}
